export default __webpack_public_path__ + "static/media/Warehouse and Storage Services.7c2440f4.jpg";